var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n    "+_vm._s(_vm.rowData.sku ? _vm.rowData.sku : _vm.$t('not_added_yet'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }